
import React, {PropTypes} from 'react';
import moment from 'moment';

class Time extends React.Component {

    static propTypes = {
        value: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.number
        ]),
        format: PropTypes.string
    };

    render() {
        const {value, format} = this.props;
        if (value === null) return <span />;

        let timeFormat = 'H:mm';
        if (!!format) timeFormat = format;

        return (
            <span>
                {moment(value).format(timeFormat)}
            </span>
        );
    }
}

export default Time;



// WEBPACK FOOTER //
// ./src/browser/components/numbers/Time.js